/* eslint-disable no-useless-computed-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { IconButton, Tooltip, Box, Typography, Button, TextField, Switch, CircularProgress, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { colors, fonts } from '../../../utils';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import { successNotify } from '../../../utils/helper';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import { setAllPresentations } from '../../../redux/slices/shareholderEducation/shareholderEducation';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const styles = {
	tableHeading: {
		fontSize: '1.3rem',
		fontWeight: '700',
		fontFamily: 'poppins, sans-serif',
	},
	tableRows: {
		fontSize: '1.3rem',
		fontFamily: 'poppins, sans-serif',
	},
};

const Presentations = () => {
	const dispatch = useDispatch();
	const { userId, fullName } = useSelector((state) => state?.activeAccount);

	const { colorWhite, colorGreenGradient } = colors;

	const { presentations } = useSelector((state) => state.shareHolderEducation);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingPdf, setIsLoadingPdf] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);

	const [formData, setFormData] = useState({
		title: '',
		description: '',
		pdf_link: '',
		image: '',
	});

	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});

	const [filters, setFilters] = useState({
		search: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [rows, setRows] = useState([]);
	const [sortedData, setSortedData] = useState([]);
	const [filtersOpen, setFiltersOpen] = useState(false);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getData(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getData(currentParams.limit, 1, clearedFilters);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getData = async (limit, page, filterParams = filters) => {
		setIsLoading(true);
		try {
			await Api.post(endPoints?.shareHolderEducation?.fetchPresentation, {
				type: "presentation",
				status: filterParams.status || "all",
				limit: limit || 50,
				page: page || 1,
				search: filterParams.search || null,
				date_from: filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
				date_to: filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllPresentations(
							response?.data?.data?.shareholderss?.data?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								creator_name: d?.creator_name,
								title: d?.title,
								description: d?.description,
								pdf_link: d?.pdf_link,
								dt: d?.dt,
								is_enabled: d?.is_enabled,
								image: d?.image,
								ordering: d?.ordering,
							})),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.shareholderss;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false);
				})
				.catch((error) => {
					setIsLoading(false);
				});
		} catch (err) {
			setIsLoading(false);
		}
	};

	const handleCreateModal = () => {
		setFormData({ title: '', description: '', pdf_link: '', image: '' });
		setOpenModal(true);
		setIsEditing(false);
	};

	const handleEditModal = (val) => {
		setFormData({
			title: val.title,
			description: val.description,
			pdf_link: val.pdf_link,
			is_enabled: val.is_enabled,
			id: val.id,
			image: val.image,
		});
		setOpenModal(true);
		setIsEditing(true);
	};

	const handleSubmit = async () => {
		setIsLoadingModal(true);

		if (!isEditing) {
			try {
				await Api.post(endPoints?.shareHolderEducation?.createPresentation, {
					...formData,
					type: "presentation",
					creator_id: userId,
					creator_name: fullName,
					is_enabled: true,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Presentation Created Successfully");
						setIsLoadingModal(false);
					})
					.catch((error) => {
						setIsLoadingModal(false);
					});
			} catch (err) {
				setIsLoadingModal(false);
			}
		} else {
			try {
				await Api.post(endPoints?.shareHolderEducation?.updatePresentation, {
					...formData,
					type: "presentation",
					creator_id: userId,
					creator_name: fullName,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Presentation Updated Successfully");
						setIsLoadingModal(false);
					})
					.catch((error) => {
						setIsLoadingModal(false);
					});
			} catch (err) {
				setIsLoadingModal(false);
			}
		}
	};

	useEffect(() => {
		getData();
	}, []);

	useEffect(() => {
		if (presentations) {
			setRows(presentations);
		}
	}, [presentations]);

	const onDragEnd = (result) => {
		if (!result.destination) return;

		const updatedRows = Array.from(rows);
		const [movedRow] = updatedRows.splice(result.source.index, 1);
		updatedRows.splice(result.destination.index, 0, movedRow);

		const updatedRowsWithSort = updatedRows.map((row, index) => ({
			...row,
			ordering: index
		}));

		setRows(updatedRowsWithSort);
		setSortedData(updatedRowsWithSort);
	};

	const handleSortSubmit = async () => {
		const items = sortedData.map((item) => ({
			id: item.id,
			ordering: item.ordering
		}));
		await Api.post(endPoints?.shareHolderEducation?.updatePresentation, { items }, {
			headers: {
				'xt-user-token': null
			}
		})
			.then((response) => {
				getData();
				successNotify("Presentations Sorting Updated Successfully");
			})
			.catch((error) => {
			});
	};

	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};

	const handleChangeTableSwitch = async (event, val) => {
		try {
			await Api.post(endPoints?.shareHolderEducation?.deletePresentation, {
				id: val.id,
				status: event.target.checked,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Presentation Status Updated Successfully");
					getData();
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};

	const handleImageUpload = (event) => {
		setIsLoadingImg(true);
		if (event.target.files.length > 0) {
			let formDataUpload = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formDataUpload.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formDataUpload, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false);
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify("Banner Uploaded Successfully");
				})
				.catch((error) => {
					setIsLoadingImg(false);
				});
		}
	};

	const handlePdfUpload = (event) => {
		setIsLoadingPdf(true);
		if (event.target.files.length > 0) {
			let formDataUpload = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formDataUpload.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formDataUpload, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingPdf(false);
					setFormData((prevState) => ({
						...prevState,
						pdf_link: response.data.data.link,
					}));
					successNotify("PDF Uploaded Successfully");
				})
				.catch((error) => {
					setIsLoadingPdf(false);
				});
		}
	};

	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Presentations
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 0 }}>
							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Title'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Status'
									state={filters.status}
									onChange={handleFilterChange}
									options={[
										{ id: 'true', description: 'Active' },
										{ id: 'false', description: 'Inactive' },
									]}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							<Flex jc='space-between' ai='center' gap='1rem' mt='1.5rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<TransitionsModal
						open={openModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Presentation" : "Create Presentation"}
						isLoading={isLoadingModal}
					>
						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.title}
									onChange={handleChange}
									label='Title'
									name='title'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.description}
									onChange={handleChange}
									label='Description'
									name='description'
								/>
							</MarginHandler>

							{/* Banner Upload */}
							<MarginHandler width='100%'>
								<Typography sx={{ fontSize: '1.4rem', mb: 1, color: '#666' }}>Banner Image</Typography>
								{isLoadingImg ?
									<CircularProgress sx={{ margin: "auto", display: "block" }} color="success" />
									:
									<>
										<input
											accept=".jpeg, .jpg, .png"
											style={{ display: 'none' }}
											id="banner-upload"
											type="file"
											onChange={(event) => handleImageUpload(event)}
										/>
										<label htmlFor="banner-upload">
											<Button
												variant="contained"
												component="span"
												fullWidth
												color='success'
												style={{ fontSize: '1em' }}
											>
												Upload Banner
											</Button>
										</label>
										{formData?.image &&
											<img height={100} style={{ marginTop: '1rem', objectFit: 'cover', borderRadius: '4px' }} src={formData?.image} alt="banner preview" />
										}
									</>
								}
							</MarginHandler>

							{/* PDF Upload or Link */}
							<MarginHandler width='100%'>
								<Typography sx={{ fontSize: '1.4rem', mb: 1, color: '#666' }}>PDF (Upload or Link)</Typography>
								<InputControl
									state={formData?.pdf_link}
									onChange={handleChange}
									label='PDF Link'
									name='pdf_link'
								/>
								<Typography sx={{ fontSize: '1.2rem', my: 1, color: '#999', textAlign: 'center' }}>OR</Typography>
								{isLoadingPdf ?
									<CircularProgress sx={{ margin: "auto", display: "block" }} color="success" />
									:
									<>
										<input
											accept=".pdf"
											style={{ display: 'none' }}
											id="pdf-upload"
											type="file"
											onChange={(event) => handlePdfUpload(event)}
										/>
										<label htmlFor="pdf-upload">
											<Button
												variant="outlined"
												component="span"
												fullWidth
												color='error'
												style={{ fontSize: '1em' }}
												startIcon={<PictureAsPdfIcon />}
											>
												Upload PDF
											</Button>
										</label>
										{formData?.pdf_link && formData?.pdf_link.includes('.pdf') &&
											<Typography sx={{ fontSize: '1.2rem', mt: 1, color: '#4caf50' }}>PDF uploaded</Typography>
										}
									</>
								}
							</MarginHandler>

							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.title}
									className='font-face-R'>
									{isEditing ? "Update" : "Create"}
								</Button>
							</MarginHandler>
						</Grid>
					</TransitionsModal>
				</Flex>

				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<DragDropContext onDragEnd={onDragEnd}>
						<Droppable droppableId="droppable" direction="vertical">
							{(provided) => (
								<TableContainer
									component={Paper}
									{...provided.droppableProps}
									ref={provided.innerRef}
								>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell style={styles.tableHeading}>Id</TableCell>
												<TableCell style={styles.tableHeading}>Title</TableCell>
												<TableCell style={styles.tableHeading}>Description</TableCell>
												<TableCell style={styles.tableHeading}>Banner</TableCell>
												<TableCell style={styles.tableHeading}>PDF</TableCell>
												<TableCell style={styles.tableHeading}>Creator</TableCell>
												<TableCell style={styles.tableHeading}>Date</TableCell>
												<TableCell style={styles.tableHeading}>Edit</TableCell>
												<TableCell style={styles.tableHeading}>Status</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{rows.map((row, index) => (
												<Draggable key={String(row.id)} draggableId={String(row.id)} index={index}>
													{(provided) => (
														<TableRow
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
														>
															<TableCell style={styles.tableRows}>{row?.id}</TableCell>
															<TableCell style={styles.tableRows}>
																{row?.title?.length > 20 ?
																	<ReadMoreReact
																		text={row?.title}
																		min={10}
																		ideal={20}
																		max={row?.title?.length}
																		readMoreText="Read More"
																	/> : row?.title}
															</TableCell>
															<TableCell style={styles.tableRows}>
																{row?.description?.length > 25 ?
																	<ReadMoreReact
																		text={row?.description}
																		min={10}
																		ideal={25}
																		max={row?.description?.length}
																		readMoreText="Read More"
																	/> : row?.description}
															</TableCell>
															<TableCell style={styles.tableRows}>
																{row?.image ? <img src={row?.image} height='60' width='80' style={{ objectFit: 'cover', borderRadius: '4px' }} alt="banner" /> : '-'}
															</TableCell>
															<TableCell style={styles.tableRows}>
																{row?.pdf_link ?
																	<a href={row?.pdf_link} target="_blank" rel="noopener noreferrer" style={{ color: '#d32f2f', display: 'flex', alignItems: 'center', gap: '4px' }}>
																		<PictureAsPdfIcon fontSize="small" /> View
																	</a> : '-'}
															</TableCell>
															<TableCell style={styles.tableRows}>{row?.creator_name}</TableCell>
															<TableCell style={styles.tableRows}>{moment(row?.dt).format("DD-MM-YYYY")}</TableCell>
															<TableCell style={styles.tableRows}>
																<Tooltip title='Edit'>
																	<IconButton onClick={() => handleEditModal(row)} aria-label='Edit'>
																		<EditIcon />
																	</IconButton>
																</Tooltip>
															</TableCell>
															<TableCell style={styles.tableRows}>
																<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, row)} checked={row?.is_enabled} name='enabled' />
															</TableCell>
														</TableRow>
													)}
												</Draggable>
											))}
										</TableBody>
									</Table>
									{provided.placeholder}
								</TableContainer>
							)}
						</Droppable>
					</DragDropContext>
				}

				<div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1em" }}>
					<ButtonCom onClickHandler={handleSortSubmit} btnTitle={"Save Sorting"} />
				</div>
			</Card>
		</>
	);
};

export default Presentations;
